import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-weight: bold;
    `,
};

productCountStyles.wrapper = {
    css: css`
        margin: 10px 0;
    `,
};
